var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfilledCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2032",
    x: 0.5,
    y: 1,
    width: 19,
    height: 19,
    rx: 2.5,
    stroke: "#808191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledCheckbox);
export default __webpack_public_path__ + "static/media/unfilledCheckbox.cd8d4b3e96ca875e4668464f6f8a2ea0.svg";
export { ForwardRef as ReactComponent };